export default __webpack_public_path__ + "static/media/carta3.c754f857.png";